import _default from './Ref';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Ref/index.js
// module id = 1121
// module chunks = 1